import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const requiredPermission = route.data['permission'] as string;

    if (!requiredPermission) {
      return true;
    }

    const hasAccess = this.authService.hasModuleAccess(requiredPermission);

    if (!hasAccess) {
      this.router.navigate(['/dashboard']);
      return false;
    }

    return true;
  }
}
